import { useMemo } from 'react';
import { TDR } from 'tdr-common';
import { useSearch } from '../api/availability/search';
import { getOpenParametersEmptyStateTables } from '../helpers/open-parameters/getOpenParametersEmptyStateTables';

export function useOpenParametersEmptySearch({
	restaurantId,
	tables,
	enabled
}: {
	restaurantId: string;
	tables: TDR.Table[];
	enabled: boolean;
}) {
	const { results, isLoading, isError } = useSearch({
		params: {},
		restaurantId,
		space: tables,
		queryEnabled: enabled
	});

	const emptyStateTables = useMemo(
		() => (enabled ? getOpenParametersEmptyStateTables(results, tables) : []),
		[enabled, results, tables]
	);

	return { emptyStateTables, isLoading, isError, results };
}
